import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ShippingTargetDialogState } from '../shipping-target-dialog.state';

/**
 * Position „Ziel-Techniker": Regel „vom Auftrag" oder fester Techniker samt
 * Umbuchungslager. Bei PickPoint hängt hier zusätzlich der Termin des
 * Abholauftrags — er ist kein Versandtermin, sondern taktet die Abholung.
 */
@Component({
  standalone: true,
  selector: 'hawk-shipping-technician-position',
  imports: [FormsModule, RouterLink, FontAwesomeModule],
  templateUrl: './technician-position.component.html',
})
export class ShippingTechnicianPositionComponent {
  protected state = inject(ShippingTargetDialogState);
  protected iconInfo = faInfoCircle;
  protected iconWarn = faExclamationTriangle;
}
